import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <Box sx={{ width: "100%", minWidth: 0, position: "relative", overflowX: "hidden" }}>
      <Outlet />
    </Box>
  );
};

export default DashboardLayout;
